import type { ReactNode } from 'react';
import React from 'react';
import { StyleSheet, View } from 'react-native';

// ─────────────────────────────────────────────────────────────────────────────

export const FloatingButtonsContainer = (
  props: FloatingButtonsContainerProps,
) => {
  const { children } = props;

  return <View style={styles.container}>{children}</View>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    right: 0,
    bottom: 0,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type FloatingButtonsContainerProps = Readonly<{
  children: ReactNode;
}>;
